import axios from "../../utils/axios";

export const getTransactions = async (page, limit, type, find) => {
    let query = "";

    // is page & limit exist
    if (page && limit) {
        query += `_page=${page}&_limit=${limit}`;
    }

    if (type) {
        query += `&type=${type}`;
    }

    if (find) {
        query += `&name=${find}`;
    }

    const response = await axios.get(`/transactions?${query}`);
    return response;
};

export const createTransaction = async (data) => {
    const response = await axios.post("/transactions", data);
    return response.data;
};

export const updateTransaction = async (id, data) => {
    const response = await axios.put(`/transactions/${id}`, data);
    return response.data;
};

export const deleteTransaction = async (id) => {
    const response = await axios.delete(`/transactions/${id}`);
    return response.data;
};
